const fs = require('fs');
const path = require('path');

//const jsdom = require("jsdom");
//const { JSDOM } = jsdom;
//const jsdom = require('react-jsdom');

// Function to convert csv to json.
function csvJSON(csv) {

    var lines = csv.split("\n");

    var result = [];

    var headers = lines[0].split(",");

    for (var i = 1; i < lines.length - 1; i++) {

        var obj = {};
        var currentline = lines[i].split(",");

        for (var j = 0; j < headers.length; j++) {
            obj[headers[j]] = currentline[j];
        }

        result.push(obj);

    }

    //return result; //JavaScript object
    return result; //JSON
}

// Function to verify YouTube subscriptions have expected format.
function verify_subscriptions(json_object) {
    var matched = 0;
    var unmatched = 0;
    for (var i = 0; i < json_object.length; ++i) {
        var keys = Object.keys(json_object[i]);
        var keys_lower = [];
        keys.forEach((element) => keys_lower.push(element.toLowerCase()));
        if (keys_lower.includes('channel id') && keys_lower.includes('channel url') && keys_lower.includes('channel title')) {
            matched++;
        }
        else {
            unmatched++;
        }
    }
    // console.log(matched, unmatched);
    if (unmatched == 0) {
        return true;
    }
    else {
        return false;
    }
}

// Function to verify that YouTube watch history has the expected format.
// Added the YouTube music condition
function verify_watch_history(json_object) {
    // console.log("OBJECT", json_object.length);
    var matched = 0;
    var unmatched = 0;
    for (var i = 0; i < json_object.length; ++i) {
        var keys = Object.keys(json_object[i]);
        var keys_lower = [];
        keys.forEach((element) => keys_lower.push(element.toLowerCase()));
        // console.log(keys_lower);
        if (keys_lower.includes('titleurl') && keys_lower.includes('time')) {
            matched++;
        }
        else {
            if (keys_lower.includes('title')){
                matched++;
            }
            // else if (json_object[i]['title'] == 'Watched a video that has been removed') {
            //     matched++;
            // }
            // else if (json_object[i]['title'] == 'Visited YouTube Music') {
            //     matched++;
            // }
            // else if (json_object[i]['title'] == 'Answered survey question') {
            //     matched++;
            // }
            else {
                // console.log("Unmatch at", json_object[i]);
                unmatched++;
            }
        }
    }
    // console.log(matched, unmatched);
    if (unmatched == 0) {
        return true;
    }
    else {
        return false;
    }
}

// Function to verify that YouTube search history has the expected format
function verify_search_history(json_object) {
    var matched = 0;
    var unmatched = 0;
    for (var i = 0; i < json_object.length; ++i) {
        var keys = Object.keys(json_object[i]);
        var keys_lower = [];
        keys.forEach((element) => keys_lower.push(element.toLowerCase()));
        // console.log(keys_lower);
        if (keys_lower.includes('title') && keys_lower.includes('time')) {
            matched++;
        }
        else {
            // console.log("Unmatched", json_object[i]);
            unmatched++;
        }
    }
    // console.log(matched, unmatched);
    if (unmatched == 0) {
        return true;
    }
    else {
        return false;
    }
}

// Function to verify that liked videos has the expected format.
function verify_liked_videos(json_object) {
    var matched = 0;
    var unmatched = 0;
    for (var i = 0; i < json_object.length; ++i) {
        if ('Video Id' in json_object[i] && 'Time Added' in json_object[i]) {
            matched++;
        }
        else {
            unmatched++;
        }
    }
    // console.log(matched, unmatched);
    if (unmatched == 0) {
        return true;
    }
    else {
        return false;
    }
}

// Function to convert html YouTube comments file to Json
function convert_youtube_comments_to_json(html, redact_comment=false) {
    var all_comments_json = [];

    // console.log('11');

    //const dom = new jsdom.JSDOM(html);
    //const dom = jsdom.render(html);
    //const dom = new jsdom(html);
    //const dom = new JSDOM(html);
    var dom = document.createElement('html');
    dom.innerHTML = html

    // console.log('22');
    
    //dom.window.document.querySelectorAll("li").forEach(entry=>{
    dom.querySelectorAll("li").forEach(entry=>{

        var splitted = entry.innerHTML.split('<br>');

        var comment = splitted[splitted.length-1];

        var info = splitted[0];
        var info_splitted_at = info.split('at ');
        var time = info_splitted_at[info_splitted_at.length-1].split('.')[0];

        var raw_html = entry.innerHTML;
        var urls = entry.getElementsByTagName("a");
        var all_urls = [];
        for (var i=0; i<urls.length; i++){
          all_urls[i] = urls[i]['href'];
        }

        // console.log(comment);

        if (redact_comment) {
        var comment_json = {
                  'comment_text': '[redacted]',
                  'video_url': all_urls[all_urls.length-1],
                  'time': time,
                  'text_content': entry.textContent.split('.')[0]
                }
        }
        else {
          comment_json = {
                  'comment_text': comment,
                  'video_url': all_urls[all_urls.length-1],
                  'time': time,
                  'text_content': entry.textContent.split('.')[0]
                }
        }
        all_comments_json.push(comment_json)
  });
  return all_comments_json;
}

function verify_comments(json_object, redact_comment=false) {
    var all_comments_json = [];
    var matched = 0;
    var unmatched = 0;
    for (var i = 0; i < json_object.length; ++i) {
        var keys = Object.keys(json_object[i]);
        var keys_lower = [];
        keys.forEach((element) => keys_lower.push(element.toLowerCase()));        
        if (keys_lower.includes('comment id') && keys_lower.includes('channel id') && keys_lower.includes('comment create timestamp') && keys_lower.includes('video id') && keys_lower.includes('comment text')) {
            matched++;
        }
        else {
            unmatched++;
        }
    }
    // console.log(matched, unmatched);
    if (unmatched == 0) {
        for (var i = 0; i < json_object.length; ++i) {
            var comment_json = json_object[i];
            var keys = Object.keys(comment_json);
            if (redact_comment) {
                for (var j = 0; j < keys.length; j++) {
                    var lowered_key = keys[j].toLowerCase();
                    if (lowered_key == 'comment text' || lowered_key == 'comment id' || lowered_key == 'parent comment id') {
                        comment_json[keys[j]] = '[redacted]';
                    }
                }
                // comment_json['Comment text'] = 
                // comment_json['Comment ID'] = '[redacted]'
                // comment_json['Parent comment ID'] = '[redacted]'
            }
            // console.log(comment_json);
            all_comments_json.push(comment_json)                        
        }
        return all_comments_json;
    }
    else {
        return null;
    } 
}

export function checkWatchHistory(watch_history) {
    // test watch history
    if (verify_watch_history(watch_history)) {
        return true;
    }
    return false;
}

export function checkSearchHistory(search_history) {
    // test search history
    if (verify_search_history(search_history)) {
        return true;
    }
    return false;
}

export function getComments(comments, redact_comment=false) {
    // console.log(redact_comment);
    // return convert_youtube_comments_to_json(comments, redact_comment);
    const jsonObj = csvJSON(comments); //convert to json
    // console.log(jsonObj);
    return verify_comments(jsonObj, redact_comment);
}

export function getSubscriptions(subscriptions) {
    const jsonObj = csvJSON(subscriptions); //convert to json
    // console.log(jsonObj);
    if (verify_subscriptions(jsonObj)) {
        return jsonObj;
    }
    return null;
}

export function getLikeHistory(likes) {
    // test like history
    var lines = likes.split('\n');
    var all_string = '';
    for (var i in lines) {
        if (lines[i].split(',').length == 2) {
            all_string = all_string.concat(lines[i] + '\n');
        }
    }
    const jsonObj = csvJSON(all_string); //convert to json
    // console.log(jsonObj);
    if (verify_liked_videos(jsonObj)) {
        return jsonObj;
    }
}